import { get } from 'app/utils/axios/kheti'
import { OrderResponse } from '../models/orderDetails'

const fetchOrderDetails = async (orderId: string) => {
  try {
    const orderDetaills = await get<OrderResponse>(
      `/farmer-360/v1/farmer/order/${orderId}`,
    )
    return orderDetaills
  } catch (e) {
    console.error(e)
  }
  return null
}

export default fetchOrderDetails
